// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__15NA1","footer":"ModalInfo_footer__3nT8W"};